import {SupportedLocale} from '@/initializers/i18next';

export type Options = {
  format?: 'full' | 'shortenName';
  locale?: SupportedLocale;
};

export const formatFullName = (firstName: string, lastName: string, options: Options): string => {
  switch (options.format) {
    case 'shortenName':
      return `${firstName} ${lastName[0]}.`;
    case 'full':
    default:
      return `${firstName} ${lastName}`;
  }
};
